// /app/ui/button/BackToListButton.tsx
"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

interface BackToListButtonProps {
  label?: string; // 기본값: "목록으로"
  onClick?: () => void;
  className?: string;
}

export default function PostBackButton({
  label = "목록으로",
  onClick,
  className = "",
}: BackToListButtonProps) {
  return (
    <div className={`flex justify-center ${className} pt-4`}>
      <button
        onClick={onClick}
        className="group flex items-center px-3 py-2 rounded-full bg-white border border-softGray-10 
                   transition-all duration-300 ease-out group-hover:px-4
                    "
      >
        <p
          className=" text-[15px] md:text-lg mx-3 text-midGray-50 transition-colors duration-300 group-hover:text-black-300 tracking-tight"
          style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
        >
          {label}
        </p>

        {/* 화살표 컨테이너 */}
        <span
          className="relative flex justify-center items-center bg-black-300 rounded-full ml-2
                     transition-all duration-300 ease-out 
                     w-8 h-8 md:w-10 md:h-10 
                     group-hover:w-11 group-hover:translate-x-[4px]"
        >
          {/* 아이콘 */}
          <FontAwesomeIcon
            icon={faArrowRight}
            className="text-white transition-transform duration-300 group-hover:translate-x-[1.5px]"
          />
        </span>
      </button>
    </div>
  );
}
